<!--
 * @Author: 黄昱森
 * @LastEditors: 黄昱森
 * @Description: 
-->
<template>
  <div class="lc-threeColumn" :style="customStyles">
    <div class="lc-threeColumn__left">
      <slot name="left" />
    </div>
    <div class="lc-threeColumn__middle">
      <slot name="middle" />
    </div>
    <div class="lc-threeColumn__right">
      <slot name="right" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'LcThreeColumn',
  props: {
    leftWidth: {
      type: String,
      default: '20%'
    },
    rightWidth: {
      type: String,
      default: '20%'
    },
    leftInterval: {
      type: String,
      default: '20px'
    },
    rightInterval: {
      type: String,
      default: '20px'
    }
  },
  data() {
    return {};
  },
  computed: {
    customStyles() {
      return {
        '--left-width': this.leftWidth,
        '--right-width': this.rightWidth,
        '--left-interval': this.leftInterval,
        '--right-interval': this.rightInterval,
      }
    },
  },
  created() {
    // preset
  },
  mounted() {
    // preset
  },
  methods: {}
};
</script>